module.exports = __webpack_public_path__ + "img/company_logo_full.5466f2ad.png";